import { combineReducers } from 'redux';
import information from './info/reducer';

const auth = window.datashop.app.module('auth');
const userData = auth.user();
const { permissions = [] } = userData || {};

/**
 * TO-DO: repalce sources with module permissions string
 */
const permissionMap = {
  canView: ['menu.can_admin']
};

const checkMap = (action) => permissions.includes(action);

const createBoolean = (list = []) => list.some(checkMap);

const actions = [...Object.keys(permissionMap)].reduce((o, a) => {
  o[a] = createBoolean(permissionMap[a]);
  return o;
}, {});

const user = (state) => {
  return {
    ...state,
    userData,
    ...actions
  };
};

const rootReducer = combineReducers({
  information,
  user
});

export default rootReducer;
